import { View } from 'foundations-components/components/View';
import AnimatedBg from './AnimatedBg';
import { jsx as _jsx } from "react/jsx-runtime";
const LabelSkeleton = () => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "160px",
    maxInlineSize: "100%",
    blockSize: "20px",
    borderRadius: "100",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(AnimatedBg, {})
  });
};
export default LabelSkeleton;